import React, { useEffect, useRef } from 'react';

//import SliderWithLabel from '../../../../../../Shared/React/js/components/sliders/SliderWithLabel';
import SpeedDataSelect from '../../home/SpeedDataSelect';

const ModalDataSlider = ({ current, values, dataLabel, changeData, dataFormat }) => {
    const popoverRef = useRef(null);

    useEffect(() => {
        const popover = wo$(popoverRef.current);
        WhistleOut.applyPopover(popover);
    }, []);

    return (
        <>
            <SpeedDataSelect
                primaryFilterAsSpeed={false}
                isModal={true}
                dataDescription={dataLabel}
                dataFormat={dataFormat}
                dataValues={values.map(value => ({
                    key: value.key,
                    value: value.value,
                    title: value.value
                }))}
                className="dropdown bootstrap-select show-tick bs3"
                data={current}
                onDataChange={changeData}
                dataWidth="100%"
            />
        </>
    );
};

export default ModalDataSlider;
